package theme

object Colors {
    object General {
        const val main = "#C7AA96"
        const val black = "#000000"
        const val grey = "#e6e4e5"
        const val harteveltRed = "#df0030"
    }
    object DarkTheme {

    }
    object LightTheme {

    }
}